var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('span',{staticClass:"material-icons",class:_vm.iconClass},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }